// Build 89 (Change 4): the By-Account picker's group heading = the account's Balance-Sheet
// classification. Prefer a payload `classification` field; else derive from `type`
// (Cash/Bank/Client/Inventory→Asset; Supplier/Loan→Liability; Revenue→Revenue;
// Expense→Expense; Equity→Equity). Purely a heading label — order is unchanged (BS order).
const CLASS_LABEL = { asset: 'Asset', liability: 'Liability', equity: 'Equity', revenue: 'Revenue', expense: 'Expense' };
const TYPE_TO_CLASS = {
  cash: 'asset', bank: 'asset', client: 'asset', customer: 'asset', inventory: 'asset', receivable: 'asset',
  supplier: 'liability', loan: 'liability', payable: 'liability',
  revenue: 'revenue', income: 'revenue',
  expense: 'expense', cogs: 'expense',
  equity: 'equity', capital: 'equity',
};
export function accountClass(a) {
  const raw = String(a.classification || TYPE_TO_CLASS[String(a.type || '').toLowerCase()] || '').toLowerCase();
  return CLASS_LABEL[raw] || 'Other';
}


